import type { TableSortOrder } from "./Types";

export const flipTableSortOrder = (
  sortOrder: TableSortOrder
): TableSortOrder => {
  return sortOrder === "asc" ? "desc" : "asc";
};
